import { ANSWERS_CONVERSATION_FORMAT } from "../components/Custom/AnswerTypeDialog/constants";

const useEditorManager = onChangePath => {
	const handleEditorInput = (type, value) => {
		const exclusiveTypes = [
			ANSWERS_CONVERSATION_FORMAT.richtext,
			ANSWERS_CONVERSATION_FORMAT.location,
			ANSWERS_CONVERSATION_FORMAT.contact,
			ANSWERS_CONVERSATION_FORMAT.menu,
			ANSWERS_CONVERSATION_FORMAT.link,
			ANSWERS_CONVERSATION_FORMAT.locationRequest
		];

		if (exclusiveTypes.includes(type)) {
			exclusiveTypes.forEach(t => {
				if (t !== type) {
					onChangePath(t, undefined);
				}
			});
		}

		onChangePath(type, value);
	};

	return handleEditorInput;
};

export default useEditorManager;
